<script setup lang="ts">
import { LINKS } from './consts'
import SocialLinks from './SocialLinks.vue'
import Text from './Text.vue'
import StatisticsInformer from './StatisticsInformer.vue'
const route = useRoute()

const currentDate = new Date()
</script>

<template>
  <footer class="mt-auto bg-white py-6 md:py-8">
    <Container>
      <div class="mb-6 flex items-center justify-between border-b pb-6 md:mb-8 md:pb-8">
        <NuxtLinkLocale to="/" :aria-label="$t('common.link_to_homepage_bankskg')">
          <Logo class="h-[38px] w-auto md:h-[38px] 3xl:h-[2.375rem]" />
        </NuxtLinkLocale>
        <SocialLinks />
      </div>
      <div class="grid grid-cols-1 gap-6 xl:grid-cols-11 xl:gap-28">
        <!--
          Rendered once and moved below the links on phones by CSS: StatisticsInformer
          is a hit counter, so a hidden second copy would double-count visits
        -->
        <div
          class="order-last flex flex-col items-start gap-4 border-b pb-6 sm:order-none sm:gap-6 sm:border-b-0 sm:pb-0 xl:col-span-3"
        >
          <Text />
          <StatisticsInformer />
        </div>
        <div
          class="grid grid-cols-1 gap-6 text-gray-600 sm:grid-cols-2 sm:gap-8 md:grid-cols-3 xl:col-span-8 hover:[&_a]:underline"
        >
          <nav
            v-for="(column, columnIndex) in LINKS"
            :key="columnIndex"
            class="border-b pb-6 sm:border-b-0 sm:pb-0"
          >
            <ul class="flex flex-col gap-4">
              <li v-for="(link, linkIndex) in column" :key="`${columnIndex}-${linkIndex}`">
                <NuxtLinkLocale
                  :to="link.url"
                  :class="{ 'text-blue-600': route.path.includes(link.url) }"
                >
                  {{ $t(link.title) }}
                </NuxtLinkLocale>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="mt-6 flex flex-wrap items-center justify-between gap-2 text-sm text-gray-500">
        <span>
          <i18n-t keypath="footer.copyright" scope="global">
            <template #year>
              {{ currentDate.getFullYear() }}
            </template>
            <template #company>
              <a
                class="underline hover:no-underline"
                href="https://intelliants.com"
                target="_blank"
              >
                Intelliants
              </a>
            </template>
          </i18n-t>
        </span>
        <span class="hidden lg:inline">{{ $t('footer.typo_hint') }}</span>
      </div>
    </Container>
  </footer>
</template>
